/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from 'react';
import { IconButton, Popper, Paper, ClickAwayListener } from '@mui/material';
import { Info } from '@mui/icons-material';

const InformationPopper = ({ information, placement = 'bottom-end' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleToggle = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!information) return null;

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <IconButton onClick={handleToggle} size="small">
          <Info />
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          style={{ zIndex: 1300 }}
        >
          <Paper sx={{ p: 1, maxWidth: 300 }}>{information}</Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default InformationPopper;

